module.exports = __webpack_public_path__ + "nc_static/media/landing-background.d5378983.png";